import { createSelector } from '@reduxjs/toolkit';

import { selectProduct } from 'src/redux/product/selectors';
import { getTaxonomyBreadcrumbsLinks } from 'src/utils/getBreadcrumbs';

export const selectBreadcrumbsLinks = createSelector([selectProduct], (product) =>
  getTaxonomyBreadcrumbsLinks(product).map(({ rel, title }) => ({ rel, text: title })),
);
